export const EARN_AND_BURN_ONLY_FACTS = new Set(['earnOrBurn', 'earnBurnOrder']);
